var _templateObject, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import styled from '@emotion/styled';
import MUISvgIcon, { svgIconClasses } from '@mui/material/SvgIcon';
import * as React from "react";
var SvgIcon = styled(MUISvgIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.", " {\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    stroke-width: 1px;\n    vector-effect: non-scaling-stroke;\n  }\n"])), svgIconClasses.root, function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return size && theme.size[size];
}, function (_ref2) {
  var size = _ref2.size,
    theme = _ref2.theme;
  return size && theme.size[size];
}, function (_ref3) {
  var color = _ref3.color,
    theme = _ref3.theme;
  return color && theme.color[color];
});
var SvgProgram = function SvgProgram(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#program_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b0bc7c",
    stroke: "currentColor",
    d: "m19.16 4.98.201.213.284-.07 10.48-2.654 9.375 9.487v22.388l-20.155 5.1-4.183-4.425-.202-.212-.284.07-4.801 1.216L.5 26.605V4.22L14.977.556z",
    vectorEffect: "non-scaling-stroke"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c2b27",
    d: "M33.113 28.16a1.56 1.56 0 0 1 1.783.968l-.642.246a.875.875 0 1 0 .029.54l.664.178a1.562 1.562 0 1 1-1.834-1.933"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2c2b27",
    fillRule: "evenodd",
    d: "M33.438 26.875a2.813 2.813 0 1 1 0 5.625 2.813 2.813 0 0 1 0-5.625m0 .619a2.193 2.193 0 1 0 0 4.387 2.193 2.193 0 0 0 0-4.387",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#597e6f",
    clipPath: "url(#program_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 8.75v15l10-2.5v-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 10.938v15L25 22.5l-4.375-6.25L25 7.5z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "program_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v40H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "program_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5 6.25h20v20H5z"
  }))))));
};
export default SvgProgram;